import React, { useRef } from 'react'
import { CmsDataFetchStatus } from '@jarvis/olex-content-management'
import useContentStack from '../hooks/useContentStack'
import Modal from '@veneer/core/dist/esm/scripts/modal'
import { ContentStackTypes } from '../store/Constants'
import classes from './GenericAlignmentHelpModal.module.scss'

export const GenericAlignmentHelpModal = ({ open, onClose }) => {
  const modalContentRef = useRef(null)

  const setModalContentRef = (element) => {
    modalContentRef.current = element
    if (element && open) {
      element.scrollTop = 0
    }
  }

  const parseContentStackModalData = (data) => {
    return {
      header: data?.header,
      introText: data?.content[0]?.copy?.copy || '',
      tryFollowingText: data?.content[1]?.copy?.copy || '',
      listItems: data?.content[2]?.simple_list?.item || [],
      closingText: data?.content[3]?.copy?.copy || ''
    }
  }

  const { status, pageData } = useContentStack(
    ContentStackTypes.modal_generic_alignment_help,
    parseContentStackModalData
  )

  if (status === CmsDataFetchStatus.LOADING) {
    return <></>
  }

  return (
    <Modal
      id="generic-alignment-modal"
      show={open}
      closeButton
      expanded
      maxWidth="720px"
      onClose={onClose}
      portal
    >
      <div className={classes.genericAlignmentHelpModal}>
        <div ref={setModalContentRef}>
          <h4 className={classes.modalHeader}>{pageData?.header}</h4>
          <div className={classes.modalContent}>
            <div
              dangerouslySetInnerHTML={{
                __html: pageData?.introText
              }}
            />
            <br />
            <div
              dangerouslySetInnerHTML={{
                __html: pageData?.tryFollowingText
              }}
            />
            <ul className={classes.modalList}>
              {pageData?.listItems.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            <br />
            <div
              dangerouslySetInnerHTML={{
                __html: pageData?.closingText
              }}
            />
          </div>
        </div>
      </div>
    </Modal>
  )
}
